export default {
  methods: {
    translateUrl(url) {
      if (this.$store.getters['common/getLang'] === 'en') {
        return url.en;
      } if (this.$store.getters['common/getLang'] === 'fr') {
        return url.fr;
      } if (this.$store.getters['common/getLang'] === 'de') {
        return url.de;
      }
    },
  },
};
